module.exports = __webpack_public_path__ + "img/arrow-left-icon-dark-grey.296b2213.svg";